import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useAuth0 } from '@auth0/auth0-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faShieldAlt, faSpinner } from '@fortawesome/free-solid-svg-icons';
import AdminFormModal from '../shared/AdminFormModal';
import AdminNotice from '../shared/AdminNotice';
import { sendPasswordResetEmail } from '../../utils/authService';

const PasswordResetModal = ({ show, onClose, userEmail }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const { getAccessTokenSilently } = useAuth0();

  const handleSendResetEmail = async () => {
    setLoading(true);
    setError('');

    try {
      await sendPasswordResetEmail(userEmail, getAccessTokenSilently);
      setSuccess(true);
    } catch (requestError) {
      console.error('Failed to send password reset email:', requestError);
      setError(requestError.message || 'Şifre sıfırlama e-postası gönderilemedi');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSuccess(false);
    setError('');
    setLoading(false);
    onClose();
  };

  return (
    <AdminFormModal
      show={show}
      onClose={handleClose}
      title="Şifre Sıfırlama E-postası Gönder"
      subtitle="Kullanıcıya güvenli şifre sıfırlama bağlantısı gönderilir."
      icon={faEnvelope}
      notice={
        success ? (
          <AdminNotice
            tone="success"
            title="E-posta gönderildi"
            message={`${userEmail} adresine şifre sıfırlama bağlantısı gönderildi.`}
            onDismiss={() => setSuccess(false)}
          />
        ) : error ? (
          <AdminNotice tone="error" title="Gönderim başarısız" message={error} onDismiss={() => setError('')} />
        ) : null
      }
      footer={(
        <>
          <div className="admin-modal-footer-secondary">
            <Button variant="secondary" onClick={handleClose} className="modal-cancel-btn">
              {success ? 'Kapat' : 'İptal'}
            </Button>
          </div>
          {!success ? (
            <div className="admin-modal-footer-primary">
              <Button variant="primary" onClick={handleSendResetEmail} className="modal-save-btn" disabled={loading}>
                <FontAwesomeIcon icon={loading ? faSpinner : faEnvelope} className={loading ? 'fa-spin' : ''} />
                {loading ? 'Gönderiliyor...' : 'E-posta Gönder'}
              </Button>
            </div>
          ) : null}
        </>
      )}
    >
      <div className="admin-form-section">
        <div className="admin-form-block">
          <div className="admin-form-block-title">
            <FontAwesomeIcon icon={faShieldAlt} />
            Güvenlik Aksiyonu
          </div>
          <div className="admin-modal-helper">
            <strong>{userEmail}</strong> adresine tek kullanımlık şifre sıfırlama bağlantısı gönderilecek. Kullanıcı bu bağlantı üzerinden yeni şifresini belirleyebilir.
          </div>
        </div>
      </div>
    </AdminFormModal>
  );
};

export default PasswordResetModal;
